const TrustBand = () => {
  return (
    <section className="bg-[#1a1f2e] py-14">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <p className="text-base text-white/60 font-light">
          Serving Commercial Mechanical, Fire Protection, and Specialty Trade Contractors Across the Southeast United States
        </p>
      </div>
    </section>
  );
};

export default TrustBand;
